import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useImperativeHandle, useRef, createRef } from "react";
import { ProviderContext } from "./Context";
const staticAction = createRef();
const Provider = ({ children, SPA = false }) => {
    const modals = useRef(new Map());
    const modalsRef = useRef(null);
    const push = (name, control) => {
        modals.current.set(name, control);
    };
    const show = (name) => {
        const modal = modals.current.get(name);
        if (modal) {
            modal.show();
        }
    };
    const hide = (name) => {
        if (name && modals.current.has(name)) {
            modals.current.get(name)?.hide();
        }
        else {
            modals.current.forEach((modal) => modal.hide());
        }
    };
    const count = () => {
        return Array.from(modals.current.values()).filter((modal) => modal.showStatus.current === true).length;
    };
    const createDynamicContainer = () => {
        if (typeof window === 'undefined') {
            const fakeDiv = document.createElement('div');
            return fakeDiv;
        }
        const nameId = '__modals-container';
        const containerModals = document.getElementById(nameId);
        if (containerModals) {
            return containerModals;
        }
        else {
            const newContainerModals = document.createElement('div');
            newContainerModals.id = nameId;
            document.body.appendChild(newContainerModals);
            return newContainerModals;
        }
    };
    if (!SPA) {
        useImperativeHandle(modalsRef, createDynamicContainer);
    }
    useImperativeHandle(staticAction, () => ({
        show,
        hide
    }));
    return (_jsxs(ProviderContext.Provider, { value: {
            push,
            modals: modalsRef,
            count
        }, children: [children, SPA && _jsx("div", { ref: modalsRef })] }));
};
export { Provider, ProviderContext, staticAction };
